const m06Section = {
  id: 'm06',
  name: '2022ScoresheetM06Sub1Label',
  fields: [
    {
      scoring: '2022ScoresheetM06Sub2Label',
      id: 'm06_scoring_1',
      options: [
        {
          description: 'noLabel',
          value: false
        },
        {
          description: 'yesLabel',
          value: true
        }
      ]
    },
    {
      scoring: '2022ScoresheetM06Sub3Label',
      id: 'm06_scoring_2',
      options: [
        {
          description: 'noLabel',
          value: false
        },
        {
          description: 'yesLabel',
          value: true
        }
      ]
    },
    {
      scoring: '2022ScoresheetM06Sub4Label',
      id: 'm06_scoring_3',
      options: [
        {
          description: 'noLabel',
          value: false
        },
        {
          description: 'yesLabel',
          value: true
        }
      ]
    },
  ]
}

export default m06Section;